import BackFixed from './backFixed';

export default class {
  constructor() {
    this.header = document.getElementById('js-header');
    this.menuButton = document.getElementById('js-menuButton');
    this.globalNav = document.getElementById('js-globalNav');
    this.backFixed = null;
    this.isOpend = false;
  }

  init() {
    this.globalNav.classList.add('is-loaded');
    this.backFixed = new BackFixed();
    this.menuButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.changeClass(event);
    });
  }

  changeClass(event) {
    const current = event.currentTarget;
    const { target } = current.dataset;
    const targetElement = document.getElementById(target);
    current.classList.toggle('-close');
    this.header.classList.toggle('-open');
    if (this.isOpend) {
      this.backFixed.init(false);
      this.isOpend = false;
      targetElement.classList.remove('-open');
    } else if (!this.isOpend) {
      targetElement.classList.add('-open');
      this.backFixed.init(true);
      this.isOpend = true;
    }
  }
}
